import { render, staticRenderFns } from "./tableSet.vue?vue&type=template&id=33d0dc64&"
import script from "./tableSet.vue?vue&type=script&lang=js&"
export * from "./tableSet.vue?vue&type=script&lang=js&"
import style0 from "./tableSet.vue?vue&type=style&index=0&id=33d0dc64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports